import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let block = document.querySelector('.service-hero');

if(block) {

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: block,
      start: 'top 80%',
    },
    defaults: { ease: 'power2.out' }
  });

  tl.from(block.querySelector('.media'), {
    x: -50,
    autoAlpha: 0.5,
    duration: 0.75
  });

  tl.from(block.querySelectorAll('.links a span, .links a p'), {
    autoAlpha: 0,
    y: 15,
    duration: 0.5,
    stagger: 0.075,
  }, '-=0.2');
}